export const cardDelivery = {
    showAlertText: true,
};
